import "./FooterQuickLinks.scss";

import React from "react";

import Link from "@mui/material/Link";

import { QuickLinkColumn } from "../../models/app-data-model";
import GlobalLink from "../global-link/GlobalLink";
import { getContentHubDamAsset } from "../../utils/get-contenthub-dam-asset";

export type FooterQuickLinksProps = {
  quickLinkColumn: QuickLinkColumn;
};

// TODO: Refactor name to be QuickLinksColumn
const FooterQuickLinks: React.FC<FooterQuickLinksProps> = ({ quickLinkColumn }) => {
  const columnHeader = quickLinkColumn?.reference[0] ? <Link href={quickLinkColumn.reference[0].url}>{quickLinkColumn.header}</Link> : quickLinkColumn?.header;
  const linkGroup = quickLinkColumn?.link_group.map((group, index) => {
    let url = group?.reference[0]?.url

    if (group?.reference[0]?.contenthub_asset) {
      const documentLink = getContentHubDamAsset(group.reference[0].contenthub_asset);
      url = documentLink?.url
    }

    return <GlobalLink url={url} key={index} label={group.title} />
  });

  return (
    <div className='footer-quick-links'>
      <h5 className='column-header'>{columnHeader}</h5>
      <span className='link-group'>{linkGroup}</span>
    </div>
  );
};

export default FooterQuickLinks;
